import { MutationTree } from 'vuex';
import { UploadVideoState } from './upload-video.store';

export const mutationVideoIsUploading = 'setVideoIsUploading';
export const mutationUploadingStatus = 'setVideoStatus';
export const mutationStartRecord = 'setRecordVideo';
export const mutationSetDocumentId = 'setDocumentId';
export const mutationVideoIsSaving = 'setVideoStatusToSaving';
export const mutationSetVideoId = 'setVideoId';
export const mutationSetVideoStreamStatus = 'setVideoStreamStatus';
export const mutationSetState = 'setState';

export const mutations: MutationTree<UploadVideoState> = {
  [mutationVideoIsUploading](state: UploadVideoState, payload: boolean) {
    state.isUploading = payload;
  },
  [mutationUploadingStatus](state: UploadVideoState, payload: string) {
    state.videoStatus = payload;
  },
  [mutationStartRecord](state: UploadVideoState, payload: boolean) {
    state.recordVideo = payload;
  },
  [mutationSetDocumentId](state: UploadVideoState, payload: string) {
    state.documentId = payload;
  },
  [mutationVideoIsSaving](state: UploadVideoState, payload: string) {
    state.videoStatus = payload;
  },
  [mutationSetState](state: UploadVideoState, newState: UploadVideoState) {
    state.documentId = newState.documentId;
    state.isUploading = newState.isUploading;
    state.recordVideo = newState.recordVideo;
    state.videoId = newState.videoId;
    state.videoStatus = newState.videoStatus;
    state.videoStreamStatus = newState.videoStreamStatus;
  },
  [mutationSetVideoId](state: UploadVideoState, payload: string) {
    state.videoId = payload;
    state.recordVideo = false;
  },
  [mutationSetVideoStreamStatus](state: UploadVideoState, payload: boolean) {
    state.videoStreamStatus = payload;
  },
};
